import { Button, type ButtonProps } from '@/components/ui/button'
import LoadingButton, { type LoadingButtonProps } from '@/components/ui/loading-button'
import { cn } from '@/lib/utils'
import type { ComponentProps } from 'react'

export type SplitButtonGroupProps = ComponentProps<'div'>

export type SplitButtonActionProps = ButtonProps & {
  grow?: boolean
}

export type SplitButtonLoadingActionProps = LoadingButtonProps & {
  grow?: boolean
}

export type SplitButtonTriggerProps = ButtonProps

const splitButtonActionClassName = 'min-w-0 rounded-r-none border-r-0'

function SplitButtonGroup({ className, ...props }: SplitButtonGroupProps) {
  return (
    <div
      role="group"
      data-slot="split-button-group"
      className={cn('inline-flex max-w-full items-stretch rounded-full', className)}
      {...props}
    />
  )
}

function SplitButtonAction({ className, grow = false, ...props }: SplitButtonActionProps) {
  return (
    <Button
      data-slot="split-button-action"
      data-split-button-part="action"
      className={cn(splitButtonActionClassName, grow && 'flex-1', className)}
      {...props}
    />
  )
}

function SplitButtonLoadingAction({
  className,
  grow = false,
  ...props
}: SplitButtonLoadingActionProps) {
  return (
    <LoadingButton
      data-slot="split-button-action"
      data-split-button-part="action"
      className={cn(splitButtonActionClassName, grow && 'flex-1', className)}
      {...props}
    />
  )
}

function SplitButtonTrigger({ className, ...props }: SplitButtonTriggerProps) {
  return (
    <Button
      data-slot="split-button-trigger"
      data-split-button-part="trigger"
      className={cn(
        'relative rounded-l-none border-l-0 px-2 before:pointer-events-none before:absolute before:inset-y-2 before:left-0 before:w-px before:bg-current before:opacity-20',
        className
      )}
      {...props}
    />
  )
}

export { SplitButtonAction, SplitButtonGroup, SplitButtonLoadingAction, SplitButtonTrigger }
